
import React, { useEffect } from 'react'
import logo from '../assets/img/logo.png'
import { useNavigate  } from "react-router-dom";

const PageNotFound = () => {

    const navigate = useNavigate()

    useEffect(() => {
        setTimeout(() => {
            navigate('/')
        }, 3000)
    //eslint-disable-next-line
    }, [])

    return (
        <div className="App">
            <header className="App-header">
                <img className="img-logo" alt="simple resume logo" src={logo}></img>
                <h1 className="mt-5">page not found</h1>
                <h3 className="mt-5">you will be redirected to the landing page</h3>
            </header>
            <div className='btn-bot'>
            </div>
        </div>
    );
}

export default PageNotFound;